import { messageError } from '../../components/message';
import { getConfig } from '../../config';
import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import { IAPIUserInfo } from '../../model/api-modules';
import { ADMIN_PREFIX, API_PREFIX } from '../config';

export const ioaLogin = (code: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const { ioaLoginConfig } = getConfig();
      const url = `${API_PREFIX}/admin-login/tof`;
      const response = await api.commonRequest('GET', url, {
        code,
        appID: ioaLoginConfig?.appID || 'ingame-devportal',
      });
      const res = await parsedResponse<{
        token: string;
        userInfo: IAPIUserInfo;
      }>(response, 'data');

      return res;
    } catch (error: any) {
      return error?.apiError;
    }
  });

export const sendIoaLogout = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/logout`;
      const response = await api.commonRequest('GET', url);
      await parsedResponse(response, 'data');
      return true;
    } catch (err: any) {
      if (err instanceof APIError) {
        messageError(err?.apiError?.message);
      }
      return false;
    }
  });
